import { GetterTree } from "vuex";

import { TrnState } from "../types";

const getters: GetterTree<TrnState, any> = {
  getTrn: (state) => state.trn,
};

export default getters;
